import { withDirectModifiedFields } from 'utils/pendingChanges';

export class LoanApplicationBorrowersApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getBorrowersTableData({ applicationId }) {
    return withDirectModifiedFields(
      await this.#http.get(`/api/applications/${applicationId}/borrowers/view`),
    );
  }

  async getBorrowersInfo({ applicationId, params }) {
    return this.#http.get(`/api/applications/${applicationId}/borrowers`, { params });
  }

  async getBorrowerInfo({ applicationId, borrowerId, params }) {
    return this.#http.get(`/api/applications/${applicationId}/borrowers/${borrowerId}`, { params });
  }
}
